import { useQuery } from "@tanstack/react-query";
import { tournamentPlayersLeaderboardQueryOptions } from "@/api/tournamentAnalysis";
import { useTournamentContext } from "../page";
import { ScoutingPlayersTable } from "@/components/general/Scouting/ScoutingPlayersTable";
import type { StatCategory } from "@/components/general/Scouting/ScoutingPlayersTable";

export const TournamentPlayersPage = () => {
    const { selectedTournamentId, tournaments, statCategory } = useTournamentContext();
    const isTournamentsLoading = tournaments === undefined;

    const { data: tournamentPlayersData, isLoading: tournamentPlayersLoading } = useQuery({
        ...tournamentPlayersLeaderboardQueryOptions(selectedTournamentId || 0),
        enabled: !!selectedTournamentId && selectedTournamentId > 0,
    });

    const playerCategory: StatCategory =
        statCategory === "overview" ||
        statCategory === "skating" ||
        statCategory === "puck" ||
        statCategory === "actions" ||
        statCategory === "passing" ||
        statCategory === "advanced"
            ? statCategory
            : "overview";

    return (
        <div className="flex-1 min-h-0 h-full flex flex-col rounded-md overflow-hidden border-table-border-color">
            <ScoutingPlayersTable
                data={tournamentPlayersData?.players || []}
                isLoading={tournamentPlayersLoading || isTournamentsLoading}
                selectedCategory={playerCategory}
            />
        </div>
    );
};
